import { menuListItems } from "assets/menu/menuList";
import { BreadCrumb } from "components/BreadCrumb";
import { GoToBack } from "components/GoToBack";
import { Header } from "components/Header";
import { Menu } from "components/Menu";
import React from "react";
import { useParams } from "react-router-dom";
import { RegistrationForm } from "../RegistrationForm";
import { HeaderContainer } from "./styles";
import { useRegistrationNew } from "./useRegistrationNew";

export const RegistrationNew: React.FC = () => {
  const { eventId } = useParams<{ eventId: string }>();

  const {
    handleChange,
    handlePersonSelect,
    inputsValues,
    touched,
    errors,
    handleSubmit,
    isLoading,
    hasError,
  } = useRegistrationNew(eventId!);

  return (
    <Menu links={menuListItems}>
      <Header>
        <HeaderContainer>
          <div>
            <GoToBack />
          </div>

          <div className="header-text">
            <BreadCrumb
              itens={["Eventos", "Detalhes", "Nova Inscrição"]}
              itemActive="Nova Inscrição"
            />
          </div>
        </HeaderContainer>
      </Header>

      <RegistrationForm
        handleChange={handleChange}
        inputsValues={inputsValues}
        touched={touched}
        errors={errors}
        handleSubmit={handleSubmit}
        isLoading={isLoading}
        hasError={hasError}
        eventId={eventId}
        onPersonSelect={handlePersonSelect}
      />
    </Menu>
  );
};
